import CsvUploadIcon from './icon-group-csv-upload.svg';
import DepartmentIcon from './icon-group-department.svg';
import EveryoneIcon from './icon-group-everyone.svg';
import LocationIcon from './icon-group-location.svg';
import TeamIcon from './icon-group-team.svg';

// @TODO clean-up old groups feature
export type GroupType = 'everyone' | 'department' | 'team' | 'location' | 'csv_upload';

export type UserRecipientAPIData = {
	id: string;
	department?: string;
	display_name: string;
	profile_pic_url: string;
	username: string;
	user_mode?: string; // normal, bot, ...
};

export type GroupRecipientAPIData = {
	id: string;
	department?: string;
	display_name: string;
	group_type: GroupType;
	group_users: UserRecipientAPIData[];
	group_user_ids: string[];
	username: string;
	user_mode: 'group';
};

export type RecipientAPIData = UserRecipientAPIData | GroupRecipientAPIData;

export type ReasonToken = {
	context: 'recipient';
	display_name: string;
	id?: string;
	type: 'username' | GroupType;
	token: string;
	user_ids: string[];
};

export class Recipient {
	readonly id: string;
	readonly dimension: '' | GroupType = ''; // group type
	readonly displayName: string;
	readonly imageSrc: string = '';
	readonly type: 'username' | 'group';
	readonly username: string;
	readonly department?: string;
	userIds: string[] = []; // users in a group

	constructor(data: RecipientAPIData) {
		const isGroup = data.user_mode === 'group';

		this.id = data.id;
		this.type = isGroup ? 'group' : 'username';
		this.displayName = data.display_name;
		this.username = data.username;
		this.department = data.department || '';

		if ('profile_pic_url' in data) {
			this.imageSrc = data.profile_pic_url;
		}

		if (isGroup && 'group_type' in data) {
			this.dimension = data.group_type;
			this.imageSrc = TEAM_ICON[data.group_type];
		}

		if ('group_users' in data) {
			this.userIds = data.group_users.map((u) => u.id);
		}

		if ('group_user_ids' in data) {
			this.userIds = data.group_user_ids;
		}
	}

	toString() {
		return this.username;
	}

	toJSON() {
		return { ...this };
	}

	static fromReasonToken(token: ReasonToken, receivers: UserRecipientAPIData[]): Recipient | undefined {
		const isUser = token.type === 'username';

		if (isUser) {
			const user = receivers.find((r) => r.id === token.user_ids[0]);
			if (user) {
				return new Recipient(user);
			}
		} else {
			const groupData: GroupRecipientAPIData = {
				id: token.token,
				display_name: token.display_name || token.token.substring(1),
				username: token.token.substring(1),
				user_mode: 'group',
				group_type: token.type as GroupType,
				group_users: [],
				group_user_ids: token.user_ids,
			};

			return new Recipient(groupData);
		}
	}
}

const TEAM_ICON: Record<GroupType, any> = {
	everyone: EveryoneIcon,
	department: DepartmentIcon,
	team: TeamIcon,
	location: LocationIcon,
	csv_upload: CsvUploadIcon,
};
